import React, { FunctionComponent, useState } from 'react'
import { RefiTransactionsRow } from './refiTransactionsRow'
import { LoanTransactionsItem } from './refiTransactionsLoanHistory.types'
import { ModalWrapper } from '../../components/modalWrapper'
export interface Props {
  loanTransactions?: LoanTransactionsItem
}

export const RefiTransactionsLoanTransactions: FunctionComponent<Props> = ({
  loanTransactions,
}) => {
  const [openCreditReportModal, setOpenCreditReportModal] = useState(false)
  const [openXmlModal, setOpenXmlModal] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  const openCreditReport = (creditReport: any) => {
    setModalContent(creditReport)
    setOpenCreditReportModal(true)
  }

  const openRequestXml = (requestXml: any) => {
    setModalContent(requestXml)
    setOpenXmlModal(true)
  }

  const renderTransactionsData = (loanTransactions: any) => {
    if (loanTransactions) {
      return (
        <>
          {loanTransactions.map((transaction, index: number) => {
            const responseData = transaction.response.data
            const requestData = transaction.request
            const hasCreditReport = responseData && responseData.credit_report
            const hasXml = requestData && requestData.xml

            const responseDataWithoutCreditReport = { ...responseData }
            const requestDataWithoutXml = { ...requestData }
            if (hasCreditReport) {
              delete responseDataWithoutCreditReport.credit_report
            }
            if (hasXml) {
              delete requestDataWithoutXml.xml
            }
            return (
              <div key={index}>
                <div
                  style={{ height: 50, zIndex: 1 }}
                  className="refiTransactionCard__title refiTransactionCard__stick-to-top refiTransactionCard__colored-background"
                >
                  Transaction {transaction.id}
                </div>
                <RefiTransactionsRow field="Event" fieldsBold hasBottomBorder>
                  {transaction.event}
                </RefiTransactionsRow>
                <RefiTransactionsRow field="Request" fieldsBold hasBottomBorder>
                  <pre>{JSON.stringify(requestDataWithoutXml, null, 2)}</pre>
                </RefiTransactionsRow>
                <RefiTransactionsRow
                  field="Response"
                  fieldsBold
                  hasBottomBorder
                >
                  <pre>
                    {JSON.stringify(responseDataWithoutCreditReport, null, 2)}
                  </pre>
                </RefiTransactionsRow>
                {openCreditReportModal && (
                  <div>
                    <ModalWrapper
                      title=""
                      width="550px"
                      height="305px"
                      hideModal={() => setOpenCreditReportModal(false)}
                    >
                      {modalContent}
                    </ModalWrapper>
                  </div>
                )}
                {openXmlModal && (
                  <div>
                    <ModalWrapper
                      title=""
                      width="550px"
                      height="305px"
                      hideModal={() => setOpenXmlModal(false)}
                    >
                      {modalContent}
                    </ModalWrapper>
                  </div>
                )}

                {hasCreditReport && (
                  <RefiTransactionsRow
                    field="Credit Report"
                    fieldsBold
                    hasBottomBorder
                  >
                    <div
                      className="refi-app__section-header"
                      onClick={() =>
                        openCreditReport(
                          transaction.response.data.credit_report
                        )
                      }
                    >
                      View
                    </div>
                  </RefiTransactionsRow>
                )}
                {hasXml && (
                  <RefiTransactionsRow
                    field="Request XML"
                    fieldsBold
                    hasBottomBorder
                  >
                    <div
                      className="refi-app__section-header"
                      onClick={() => openRequestXml(transaction.request.xml)}
                    >
                      View
                    </div>
                  </RefiTransactionsRow>
                )}
              </div>
            )
          })}
        </>
      )
    } else {
      return <>No loan transactions</>
    }
  }

  return (
    <div className="refi-transactions-info">
      <div className="refi-transactions-info__information">
        {renderTransactionsData(loanTransactions)}
      </div>
    </div>
  )
}

RefiTransactionsLoanTransactions.displayName =
  'RefiTransactionsLoanTransactions'
